import { ColumnDefinitionEnum } from '@mark43/cad-api';

// Fields to unmask in Datadog session replays for the FR events compact view
export const FR_EVENT_QUEUE_UNMASKED_COLUMNS = new Set<string>([
    ColumnDefinitionEnum.PRIORITY.name,
    ColumnDefinitionEnum.EVENT_NUMBER.name,
    ColumnDefinitionEnum.EVENT_NUMBER_LAST_4_DIGITS.name,
    ColumnDefinitionEnum.CFS_NUMBER_AND_TEXT.name,
    ColumnDefinitionEnum.CFS_NUMBER.name,
    ColumnDefinitionEnum.CFS_TEXT.name,
    ColumnDefinitionEnum.DISPATCH_AREA.name,
    ColumnDefinitionEnum.ASSIGNED_UNITS.name,
]);

// Fields to unmask in Datadog session replays for the FR BOLO compact view column headers
export const FR_BOLO_QUEUE_UNMASKED_COLUMN = new Set<string>([
    ColumnDefinitionEnum.BOLO_PRIORITY.name,
    ColumnDefinitionEnum.BOLO_NUMBER.name,
    ColumnDefinitionEnum.BOLO_DESCRIPTION.name,
    ColumnDefinitionEnum.BOLO_DISPATCH_AREAS.name,
]);

export const INITIAL_COMPACT_COLS = [
    "PRIORITY",
    "EVENT_LOCATION",
    "CFS_TEXT",
    "DISPATCH_AREA",
    "EVENT_NUMBER",
    "ASSIGNED_UNITS"
];

export const DEFAULT_COL_MIN_HEIGHT = 63;
export const DEFAULT_AS_COL_WIDTH = 160;

export const MUTATION_OBSERVER_OPT = {
    config: {
        attributes: true,
        attributeFilter: ['style'],
    },
};

export const RECT_WIDTH_RESIZE_STEP = 18;
